/**
 * Rebuy widgets (126937, 271591) – apply the largest title height to all product titles
 * on mobile so prices align; normalize review count to "(164)" with no "Reviews" or space.
 *
 * Also clears the reserved-height floor on widgets 126936/126937 (set in
 * theme.css.liquid against their static app-block wrapper) when Rebuy is
 * blocked, fails, or has no recommendations — otherwise that reservation
 * assumes real content always grows past it and never gets removed.
 */
(function () {
  var WIDGET_IDS = ['rebuy-widget-126937', 'rebuy-widget-271591'];
  var RESERVATION_IDS = ['126936', '126937'];
  var MOBILE_MAX = 768;
  var MAX_ATTEMPTS = 20;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  /** Show only (number), e.g. "(164)", no "Reviews" text or space */
  function normalizeReviewCounts(widget) {
    if (!widget) return;
    widget.querySelectorAll('.rebuy-review-count').forEach(function (el) {
      var numEl = el.querySelector('.rebuy-review-count-number');
      if (numEl) {
        var num = numEl.textContent.trim();
        el.textContent = '(' + num + ')';
      }
    });
  }

  function equalizeOneWidget(widget) {
    if (!widget) return;
    widget.querySelectorAll('.rebuy-product-info .rebuy-product-title').forEach(function (title) {
      title.style.minHeight = '';
    });
  }

  function clearHeights() {
    WIDGET_IDS.forEach(function (id) {
      var widget = document.getElementById(id);
      if (!widget) return;
      widget.querySelectorAll('.rebuy-product-info .rebuy-product-title').forEach(function (title) {
        title.style.minHeight = '';
      });
    });
  }

  function setupWidget(widget) {
    if (!widget || widget.getAttribute('data-rebuy-carousel-align-init') === '1') return;
    widget.setAttribute('data-rebuy-carousel-align-init', '1');

    normalizeReviewCounts(widget);
    if (isMobile()) equalizeOneWidget(widget);

    var observerTimeout;
    var observer = new MutationObserver(function () {
      clearTimeout(observerTimeout);
      observerTimeout = setTimeout(function () {
        normalizeReviewCounts(widget);
        if (isMobile()) equalizeOneWidget(widget);
      }, 100);
    });
    observer.observe(widget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function trySetupAllWidgets() {
    WIDGET_IDS.forEach(function (id) {
      var w = document.getElementById(id);
      if (w) setupWidget(w);
    });
  }

  function allPresentWidgetsInited() {
    return WIDGET_IDS.every(function (id) {
      var w = document.getElementById(id);
      return !w || w.getAttribute('data-rebuy-carousel-align-init') === '1';
    });
  }

  function reservationHasContent(widgetEl) {
    return !!widgetEl && widgetEl.querySelector('.rebuy-product-block, .rebuy-product-info') !== null;
  }

  function resolveReservations(attempts) {
    RESERVATION_IDS.forEach(function (id) {
      var wrapper = document.querySelector('[data-rebuy-id="' + id + '"]');
      if (!wrapper || wrapper.hasAttribute('data-rebuy-resolved')) return;

      var widgetEl = document.getElementById('rebuy-widget-' + id);

      if (reservationHasContent(widgetEl)) {
        wrapper.setAttribute('data-rebuy-resolved', '');
      } else if (attempts >= MAX_ATTEMPTS) {
        wrapper.setAttribute('data-rebuy-resolved', '');
        wrapper.setAttribute('data-rebuy-empty', '');
      }
    });
  }

  function allReservationsResolved() {
    return RESERVATION_IDS.every(function (id) {
      var wrapper = document.querySelector('[data-rebuy-id="' + id + '"]');
      return !wrapper || wrapper.hasAttribute('data-rebuy-resolved');
    });
  }

  function init() {
    if (!isMobile()) clearHeights();

    trySetupAllWidgets();
    resolveReservations(0);

    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      trySetupAllWidgets();
      resolveReservations(attempts);
      if ((allPresentWidgetsInited() && allReservationsResolved()) || attempts >= MAX_ATTEMPTS) {
        clearInterval(interval);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('rebuy.ready', init);
})();
